module.exports = __webpack_public_path__ + "img/tick-icon.3d136a12.png";